module.exports = __webpack_public_path__ + "overview-a5b6df21/upload-a3282b78793010826cfdc2dc9eb81607.svg";